export enum DownloadType {
  GENERIC = 'octet/stream',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
}

export const downloadFile = (buffer: any, fileNameWithExtension: string, type: DownloadType = DownloadType.GENERIC) => {
  const anchor: HTMLAnchorElement = document.createElement('a');

  document.body.appendChild(anchor);
  anchor.setAttribute('hidden', 'hidden');
  const blob: Blob = new Blob([buffer], { type });
  const url: string = window.URL.createObjectURL(blob);

  anchor.href = url;
  anchor.download = fileNameWithExtension;
  anchor.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(anchor);
};
